var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubbleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5088 0C11.8157 0 0.00554674 12.1372 0.00544812 26.9163L0 52.6876C0 65.1726 8.59692 76.1147 20.3601 78.8733V92.764C20.3601 95.6276 21.9269 98.2144 24.4787 99.355C25.4632 99.8466 26.5718 100 27.4849 100C29.1749 100 30.7981 99.5273 32.1088 98.2157L52.5592 80.2668C52.9665 79.9637 53.6118 79.7485 54.1182 79.7485H73.4966C88.1898 79.7485 100 67.6112 100 52.832V26.9164C100 11.9943 88.049 0 73.4966 0H26.5088ZM26.51 8.80737L73.363 8.8068C83.2087 8.8068 91.194 16.9161 91.194 26.9159V52.5441C91.194 62.5434 83.2092 70.6532 73.363 70.6532H53.9843C51.3892 70.6532 48.8299 71.733 46.8825 73.4078L29.0391 89.1648V76.3353C29.0391 73.5021 26.9135 71.0012 24.1073 70.6656C15.3355 69.5844 8.67879 61.8884 8.67879 52.8322V26.9164C8.67879 16.9172 16.6636 8.80737 26.51 8.80737Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleOutline);
export default __webpack_public_path__ + "static/media/chat_bubble_outline.087bafb37d93f3ec360238d300d5d137.svg";
export { ForwardRef as ReactComponent };